import { environment } from 'src/environments/environment';

function loadCSS(href: string) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.type = 'text/css';
  link.href = href;
  document.head.appendChild(link);
}

/**
 * Injects the external CSS bundles as <link> tags. Called from main.ts before
 * Angular bootstraps so the request (and the Glyphicons Halflings font it carries)
 * starts downloading immediately, instead of waiting on ngOnInit after the app renders.
 */
export function loadExternalAssets() {
  loadCSS(`${environment.assetsEndpoint}shared/scss/apps/vendors/bootstrap-3.3.7-dist/css/bootstrap.min.css`);
  loadCSS(`${environment.assetsEndpoint}dist/css/traxpartners.css`);
}
